feeJS.classListDocReady = {
  Accordion,
  FormMultipage,
  FormProgress,
  FormValidation,
  ResponsiveVideo,
  SelectColors,
  Slider,
  Tabs
};



feeJS.classListOnLoad = {
  Dialogs,
  MainNavObserver,
  Marquee,
  RegionFilter
};



feeJS.classParams = {

  Accordion: {
    selAccordion: '.js-accordion',
    selTitle: '.js-navWidgetTitle',
    selContent: '.js-navWidgetContent',
    getCssCustomProperty: feeJS.getCssCustomProperty
  },

  Dialogs: {
    selDialog: '.js-dialog',
    selOpeningHandle: '.js-openDialog',
    selClosingHandle: '.js-closeDialog'
  },

  FormProgress: {
    selForm: '.js-showProgress',
    selBar: '.js-progressBar',
    selValue: '.js-progressValue',
    selField: '.js-progressField'
  },

  FormMultipage: {
    selForm: '.js-ngo-form',
    selSection: '.c-form__section',
    selBreadcrumbItem: '.c-form__breadcrumbItem',
    selBreadcrumbLink: '.js-breadcrumb-link',
    selNextBtn: '.js-section-next',
    selPrevBtn: '.js-section-prev',
    selSummary: '.js-form-summary',
    selFestivalToggle: '.js-festival-participate',
    selCarPassesToggle: '.js-additional-carpasses-toggle',
    selWorkshopToggle: '.js-workshop-toggle',
    selPhoneField: '[data-validation="phone"]'
  },

  FormValidation: {
    selForm: '.js-validate',
    availableLocales: ['de', 'en'],
    config: {
      classTo: 'c-form__item',
      errorClass: 'is-invalid',
      successClass: 'is-valid',
      errorTextParent: 'c-form__item',
      errorTextTag: 'div',
      errorTextClass: 'text-help'
    }
  },

  MainNavObserver: {
    selMainNav: '.js-mainNavigation'
  },

  Marquee: {
    requiredElements: [
      'container',
      'animated',
      'item'
    ],
    selMarquee: '.js-marquee',
    selContainer: '.js-marqueeContainer',
    selAnimated: '.js-marqueeAnimated',
    selItem: '.js-marqueeItem',
    clones: 3
  },

  RegionFilter: {
    selFilter: '.js-tabFilter',
    selFilterSelect: '.js-filterSelect',
    selFilterList: '.js-filterList',
    selFilterLink: '.js-filterLink',
    selFilterItem: '.js-filterItem'
  },

  ResponsiveVideo: {
    selVideo: '.js-responsiveVideo',
    viewportMap: {
      'tiny': 'mobile',
      'small': 'mobile',
      'medium': 'tablet',
      'large': 'desktop',
      'xxl': 'desktop'
    },
    getCssCustomProperty: feeJS.getCssCustomProperty,
    debounceThenExecute: feeJS.debounceThenExecute
  },

  SelectColors: {
    selSelect: '.js-setSelectColor'
  },

  Slider: {
    selSlider: '.js-slider',
    config: SLIDER_CONFIG,
    generateRandomString: feeJS.generateRandomString
  },

  StickyObserver: {
    selSticky: '.js-markWhenStuck'
  },

  Tabs: {
    selModule: '.js-tabs',
    selTabTitle: '.js-tabTitle',
    selTabContent: '.js-tabContent'
  }
}
